/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Rights_TabInputs */



/**
* | output |
* | --- |
* | "Rights & Roles" |
*
* @param {Admin_Settings_Rights_TabInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_settings_rights_tab = /** @type {((inputs?: Admin_Settings_Rights_TabInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Rights_TabInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Rechte & Rollen")
	return /** @type {LocalizedString} */ ("Rights & Roles")
});